
namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class TestGroupTestGrid extends SiteEntityGrid<TestGroupTestRow, any> {
        protected getColumnsKey() { return 'Data.TestGroupTest'; }
        protected getDialogType() { return TestGroupTestDialog; }
        protected getIdProperty() { return TestGroupTestRow.idProperty; }
        protected getLocalTextPrefix() { return TestGroupTestRow.localTextPrefix; }
        protected getService() { return TestGroupTestService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}